<h1 class="u-title-xl">
	<img alt="IVV icon" src="/assets/img/ivv-icon.svg" />
	{{ title | translate: { currentYear: year || CURRENT_YEAR } }}
</h1>
